import Vue from 'vue';
const resource = '/workorderitemorderitems';

export default {
  linkWorkOrderItemOrderItem(payload) {
    return Vue.prototype.$axiosMainClient.put(`${resource}/link`, payload);
  },
  linkWithWorkOrder(payload) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/workOrderLink`,
      payload
    );
  },
  cancelOrdered(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/cancelOrdered`,
      payload
    );
  },
};
